import { useForm } from "react-hook-form";
import "./style.scss";
import BtnDefault from "../../BtnDefault/BtnDefault";
import { useAutocomplete } from "@/src/hooks/useAutocomplete";
import { coverLetter, selectEmail } from "@/src/constants/documentsQRCode";
import AutocompleteInput from "../../AutocompleteInput/AutocompleteInput";
import { FC } from "react";
import { useDispatch } from "react-redux";
import { admissionOfficeRequests } from "@/src/api/admissionOfficeDocCreateRequests";
import { setIsPreloyder } from "@/src/store/slices/Preloyder/PreloyderSlice";

interface IFormEmail {
  isName: string;
  isSeria: string;
}

interface IFormEmailValues {
  sender_email: string;
  recipient_email: string;
  subject_email: string;
  body_email: string;
}

const FormEmail: FC<IFormEmail> = ({ isName, isSeria }) => {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm<IFormEmailValues>({
    defaultValues: {},
  });
  const dispatch = useDispatch();

  const selectEmailAuto = useAutocomplete(selectEmail);
  const coverLetterAuto = useAutocomplete(coverLetter.map((i) => i.label));

  const sendEmail = async () => {
    const values = getValues();
    const payload = {
      seria: isSeria,
      name: isName,
      body_email: values.body_email,
      sender_email: values.sender_email,
      recipient_email: values.recipient_email,
      subject_email: values.subject_email,
    };
    dispatch(setIsPreloyder(true));
    try {
      let response = await admissionOfficeRequests.createDocumentsEmailDoc(payload);
      if (response) {
        alert("Success send email!");
        console.log(response, "resonse");
      }
    } catch (error) {
      alert("An unexpected error occurred - write to the developers");
    } finally {
      dispatch(setIsPreloyder(false));
    }
  };

  return (
    <form className="form-email">
      <div className="form-email-fields">
        <div className="form-email-fields-input sender_email">
          <AutocompleteInput
            label="Select Email"
            value={selectEmailAuto.query}
            onChange={selectEmailAuto.onChange}
            onSelect={(v) => {
              selectEmailAuto.onSelect(v);
              setValue("sender_email", v);
            }}
            isOpen={selectEmailAuto.isOpen}
            options={selectEmailAuto.filtered}
            error={!!errors.sender_email}
            required
            inputProps={{
              register: register("sender_email", { required: true }),
              close: selectEmailAuto.close,
              setOpen: selectEmailAuto.onClick,
            }}
            identifier={"sender_email"}
          />
        </div>
        <div className="form-email-fields-input">
          <div className="form-email-fields-input-label">
            <label htmlFor="recipient_email">
              Where to send<span>*</span>
            </label>
            <div className="form-email-fields-input-label-line"></div>
          </div>
          <input className="recipient_email" id="recipient_email" type="text" {...register("recipient_email", { required: true })} />
          {errors.recipient_email && <p>This field is required</p>}
        </div>
      </div>
      <div className="form-email-fields">
        <div className="form-email-fields-input">
          <div className="form-email-fields-input-label">
            <label htmlFor="subject_email">
              Subject email<span>*</span>
            </label>
            <div className="form-email-fields-input-label-line"></div>
          </div>
          <input className="subject_email" id="subject_email" type="text" {...register("subject_email", { required: true })} />
          {errors.subject_email && <p>This field is required</p>}
        </div>
      </div>
      <div className="form-email-fields">
        <AutocompleteInput
          label="Cover letter text for transcript"
          value={coverLetterAuto.query}
          onChange={coverLetterAuto.onChange}
          onSelect={(label) => {
            const selected = coverLetter.find((i) => i.label === label);

            if (!selected) return;

            coverLetterAuto.onSelect(label);

            setValue("body_email", selected.value);
          }}
          isOpen={coverLetterAuto.isOpen}
          options={coverLetterAuto.filtered}
          error={!!errors.body_email}
          required
          inputProps={{
            register: register("body_email", { required: true }),
            close: coverLetterAuto.close,
            setOpen: coverLetterAuto.onClick,
          }}
          identifier={"body_email"}
        />
      </div>
      <div className="form-email-button">
        <BtnDefault onClick={handleSubmit(sendEmail)}>
          <p>Send</p>
        </BtnDefault>
      </div>
    </form>
  );
};

export default FormEmail;
